import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  height: 24px;
  width: 24px;
`

export const ShieldIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M12 21.4813C9.83717 20.8915 8.0465 19.6184 6.628 17.6621C5.20933 15.7057 4.5 13.5186 4.5 11.1006V5.34681L12 2.53906L19.5 5.34681V11.0121C19.2667 10.9172 19.0217 10.8316 18.7653 10.7553C18.5089 10.6791 18.2538 10.6192 18 10.5756V6.39106L12 4.15056L6 6.39106V11.1006C6 11.9864 6.125 12.8515 6.375 13.6958C6.625 14.54 6.96958 15.3291 7.40875 16.0631C7.84775 16.7971 8.37242 17.4561 8.98275 18.0401C9.59292 18.6241 10.2551 19.0904 10.9692 19.4391L10.9983 19.4293C11.1302 19.796 11.3013 20.1473 11.5115 20.4833C11.7218 20.8191 11.9609 21.1242 12.2287 21.3986C12.1866 21.4114 12.1485 21.4252 12.1145 21.4401C12.0805 21.4547 12.0423 21.4685 12 21.4813ZM17 21.5006C15.7513 21.5006 14.6892 21.0627 13.8135 20.1871C12.9378 19.3114 12.5 18.2492 12.5 17.0006C12.5 15.7519 12.9378 14.6897 13.8135 13.8141C14.6892 12.9384 15.7513 12.5006 17 12.5006C18.2487 12.5006 19.3108 12.9384 20.1865 13.8141C21.0622 14.6897 21.5 15.7519 21.5 17.0006C21.5 18.2492 21.0622 19.3114 20.1865 20.1871C19.3108 21.0627 18.2487 21.5006 17 21.5006ZM16.5577 19.7506H17.4423V17.4428H19.75V16.5583H17.4423V14.2506H16.5577V16.5583H14.25V17.4428H16.5577V19.7506Z" />
    </Svg>
  )
}
